export default import.meta.ROLLUP_FILE_URL_NNsvqOhmq3DQU_dkkxRomg